<template>
  <div class="fcp-page">
    <template v-if="from != 'introDetail'">
      <Header />
      <div id="block"></div>
      <Box1 />
    </template>
    <Box2 />
    <Box3 />
    <Box4 />
    <Box5 />
    <Box6 />
    <Box7 />
    <Box8 />
    <pageRightFloat pageName="法国INSEEC" />
    <Footer />
  </div>
</template>

<script>
  import pageRightFloat from "../common/pageRightFloat.vue";
  import Header from "../common/Header.vue";
  import Footer from "../common/Footer.vue";
  import Box1 from "./box1.vue";
  import Box2 from "./box2.vue";
  import Box3 from "./box3.vue";
  import Box4 from "./box4.vue";
  import Box5 from "./box5.vue";
  import Box6 from "./box6.vue";
  import Box7 from "./box7.vue";
  import Box8 from "./box8.vue";

  export default {
    name: "",
    components: {
      pageRightFloat,
      Header,
      Footer,
      Box1,
      Box2,
      Box3,
      Box4,
      Box5,
      Box6,
      Box7,
      Box8,
    },
    data() {
      return {
        from: "",
      };
    },
    mounted() {
      this.from = this.getQueryString("from");
    },
    methods: {},
  };
</script>
<style lang="scss">
  body,
  html {
    overflow-x: hidden;
  }
</style>
<style lang="scss" scoped>
  #block {
    width: 100%;
    height: 88px;
  }
</style>
